<template>
  <v-menu
      v-model="showPopup"
      :close-on-content-click="false"
      lazy
      transition="scale-transition"
      offset-y
      max-width="290"
      :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
          v-model="date"
          readonly
          persistent-hint
          v-on="on"
          :rules="dateRules"
          :prepend-inner-icon=prependInnerIcon?prependInnerIcon:undefined
          :error-messages="errorMessages"
          :disabled="disabled"
          :flat="flat"
          :solo="solo"
          :background-color="backgroundColor"
          :placeholder="placeholder"
          :append-icon="appendIcon"
          @click:append="showPopup=true"
          :hide-details="hideDetails"
          outline
          height="38"
      >
        <template v-slot:append>
          <v-icon size="20">mdi-menu-down</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        no-title
        show-current
        :min="min"
        :max="max"
        ref="VDatePicker"
        :disabled="disabled"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
import FormMixin from '@/mixins/FormMixin'

export default {
  name: 'DatePickerOutline',
  mixins: [FormMixin],
  props: {
    value: String,
    label: String,
    rules: Array,
    min: String,
    max: String,
    errorMessages: String,
    prependInnerIcon: {
      type: String,
      default: ""
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    appendIcon: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    solo: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      showPopup: false,
      date: this.value
    }
  },
  computed: {
    dateRules () {
      if (this.rules) {
        return [
          this.formRules.ruleDatePicker,
          ...this.rules
        ]
      } else {
        return [this.formRules.ruleDatePicker]
      }
    }
  },
  watch: {
    value (value) {
      this.date = value
      this.$emit('change', value)
    },
    date () {
      this.$emit('input', this.date)
      this.showPopup = false
    },
    showPopup: {
      handler: function (val) {
        if (val) {
          // show view at current value > min value or current month on open date picker
          this.$nextTick(() => {
            if (this.value) {
              this.$refs.VDatePicker.tableDate = moment(this.value).format('YYYY-MM')
              return
            }
            let today = moment().format('YYYY-MM')
            let viewDay = today
            if (this.min) {
              let minDay = moment(this.min)
              if (minDay.diff(today, 'days') > 0) {
                viewDay = minDay.format('YYYY-MM')
              }
            }
            this.$refs.VDatePicker.tableDate = viewDay
          })
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  min-height: 38px;
}

::v-deep.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
  border: 1px solid #D9D9D9 !important;
}

::v-deep.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {
  margin-top: 0 !important;
}

::v-deep.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: white !important;
}

::v-deep.v-text-field .v-input__append-inner {
  margin-top: 8px !important;
}
::v-deep input {
  font-size: 14px;
}
::v-deep.v-text-field--outline input {
  margin-top: 4px !important;
}

</style>
